// +-------------------------------------------------------------
// | Created by WebStorm.
// +-------------------------------------------------------------
// | User: msmile
// +-------------------------------------------------------------
// | Date: 2024/2/2
// +-------------------------------------------------------------
// |Time: 10:51
// +-------------------------------------------------------------
import {defineStore} from "pinia";
import {getProfile} from "@/api/user";

export const useUserStore = defineStore({
    id: 'user',
    state: () => {
        return {
            token: '',
            // 用户信息
            userInfo: [],
            isOpen:false,
        }
    },
    actions: {
        async updateUserInfo(){
            const { data, code } = await getProfile();
            if(code == 200) {
                this.userInfo = data;
            }
        }
    },
    persist: {
        storage: localStorage,
        paths: ['token', 'userInfo'],
    }
})
